import { getPriceIndexFromRomeo } from './getPriceIndexFromRomeo'

export const getArtistIndexData = async ({
  artworkData,
  yearsBack = 5,
}: {
  artworkData: any
  yearsBack?: number
}) => {
  const currentYear = new Date().getFullYear()

  const newItem = artworkData

  if (!newItem.artworkArtists || !Array.isArray(newItem.artworkArtists)) {
    return newItem
  }

  const indexData = newItem.artworkArtists.map(async (artist: any) => {
    const artistIdentifier = artist.id || artist._id
    const artistId = artistIdentifier.split('-')[1]

    const response = await getPriceIndexFromRomeo({
      artistId,
      currentYear,
      fromYear: yearsBack,
    })
    return {
      artistId: response.artistId,
      data: response.data.series ?? [],
    }
  })
  const collectionData = (await Promise.all(indexData)).filter(
    item => item !== null
  )

  newItem['collectionData'] = collectionData

  return newItem
}
